export default {
    LOAD_STUDENT_CONCEPT_DATA_SUCCESS:'LOAD_STUDENT_CONCEPT_DATA_SUCCESS',
    LOAD_STUDENT_CONCEPT_DATA_FAILURE:'LOAD_STUDENT_CONCEPT_DATA_FAILURE',
}